import { all, call } from 'redux-saga/effects'

import cmiSaga from './cmi'
import playerSaga from './player'
import presentationSaga from './presentation'

export default function* rootSaga() {
  yield all([call(cmiSaga), call(playerSaga), call(presentationSaga)])
}
